var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4H5V15.8C5 16.92 5 17.48 5.218 17.908C5.40974 18.2843 5.71569 18.5903 6.092 18.782C6.52 19 7.08 19 8.2 19H15.8C16.92 19 17.48 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.48 19 16.92 19 15.8V4ZM11 15V11.414L9.707 12.707C9.5184 12.8892 9.2658 12.99 9.0036 12.9877C8.7414 12.9854 8.49059 12.8802 8.30518 12.6948C8.11977 12.5094 8.0146 12.2586 8.01233 11.9964C8.01005 11.7342 8.11084 11.4816 8.293 11.293L11.187 8.399C11.205 8.381 11.224 8.36333 11.244 8.346C11.3377 8.23728 11.4537 8.15005 11.5842 8.09026C11.7147 8.03046 11.8565 7.99951 12 7.99951C12.1435 7.99951 12.2853 8.03046 12.4158 8.09026C12.5463 8.15005 12.6623 8.23728 12.756 8.346C12.776 8.36333 12.795 8.381 12.813 8.399L15.707 11.293C15.8892 11.4816 15.99 11.7342 15.9877 11.9964C15.9854 12.2586 15.8802 12.5094 15.6948 12.6948C15.5094 12.8802 15.2586 12.9854 14.9964 12.9877C14.7342 12.99 14.4816 12.8892 14.293 12.707L13 11.414V15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071C11.1054 15.5196 11 15.2652 11 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerLoad);
export default __webpack_public_path__ + "static/media/serverLoad.f3cc158320dbd5741a25814aefb7dedc.svg";
export { ForwardRef as ReactComponent };